var map = {
	"./activities-light.svg": "ad49",
	"./activities.svg": "027c",
	"./addresses-light.svg": "3706",
	"./addresses.svg": "a727",
	"./booking-light.svg": "9ca9",
	"./booking.svg": "dc91",
	"./bookings-light.svg": "dfc0",
	"./bookings.svg": "1ce0",
	"./box-light.svg": "602f",
	"./box.svg": "4f70",
	"./calendar-light.svg": "a429",
	"./calendar.svg": "bcfc",
	"./camps-light.svg": "3252",
	"./camps.svg": "6872",
	"./contacts-light.svg": "46ba",
	"./contacts.svg": "77d6",
	"./envelope-light.svg": "c93c",
	"./envelope.svg": "38e9",
	"./events-light.svg": "24f6",
	"./events.svg": "2115",
	"./financial-light.svg": "8536",
	"./financial.svg": "0a13",
	"./home-light.svg": "d796",
	"./home.svg": "6961",
	"./overview-light.svg": "96b6",
	"./overview.svg": "3e22",
	"./users-light.svg": "3bc3",
	"./users.svg": "ef8a",
	"./wallet-light.svg": "0608",
	"./wallet.svg": "eed1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9bd8";